import { motion } from 'framer-motion'
import { colors } from '@/theme/colors'

export function LoadingScreen() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: colors.primary[500],
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        style={{
          textAlign: 'center',
          color: colors.white,
        }}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear',
          }}
          style={{
            width: 60,
            height: 60,
            border: `4px solid ${colors.white}20`,
            borderTop: `4px solid ${colors.white}`,
            borderRadius: '50%',
            margin: '0 auto 20px',
          }}
        />
        <p style={{ fontSize: '18px', fontWeight: 500 }}>Cargando...</p>
      </motion.div>
    </div>
  )
}
